// Framework and third-party non-ui
import * as React from 'react';

// Hooks, context, and constants
import { useAuthContext } from 'contexts';

// App components

// JSON & Styles
import { SignOutWrapper, SignOutButton } from './SignOut-styled';

// Third-party components (buttons, icons, etc.)

export const SignOut = () => {
  // State and Constants
  const AuthContext = useAuthContext();

  // Actions
  const handleSignOut = () => {
    AuthContext.signOut();
  };

  // Effects

  return (
    <SignOutWrapper>
      <SignOutButton onClick={handleSignOut}>
        <div aria-hidden="true" className="button-icon esri-icon-sign-out" />
        Sign out
      </SignOutButton>
    </SignOutWrapper>
  );
};
